import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  pure: true
})
export class HighlightPipe implements PipeTransform {

  transform(input: string, match: string): string {

    if (!match) { return input; }
    if (input === undefined || input === null) { return ''; }

    const safeInput = typeof input === 'string' ? input : String(input);

    // make a regex from the highlight string, but with all regex reserved characters escaped
    const re = new RegExp(match.replace(/([\.\[\]\(\)\?\*\+\-])/g, '\\$1'), 'gi');
    return `<span>${safeInput.replace(re, '<span class="highlight">$&</span>')}</span>`;
  }
}
